export default "__VITE_ASSET__CJxrMRM5__"